<template>
    <div>
        <div class="tab-list d-flex align-items-center justify-content-between">
            <ul class="d-flex align-items-center pl-4 mb-0 mt-7">
                <li class="d-flex align-items-center pointer">
                    <span class="list-text">Emergency Contact</span>
                    <span class="mx-2">|</span>
                    <span class="list-text-count">0 Total</span>
                </li>
            </ul>
            <div>
                <!-- <button @click="showCreateModal" class="btn btn-success text-white text-capitalize">
                    + Add New Contact
                </button> -->
            </div>
        </div>
        <div class="content mt-3">
            <div>
                <div class="table-content mb-3" style="overflow-x: auto !important;">
                    <table class="table table-content-data table-responsive" style="border: solid 0.5px #f2f3f5;border-radius: 8px;">
                        <thead>
                            <tr>
                                <th class="whiteSpace w-1">
                                    CONTACT NAME
                                </th>
                                <th class="whiteSpace w-1">
                                    DEPARTMENT
                                </th>
                                <th class="whiteSpace w-1">
                                    PHONE NUMBER
                                </th>
                                <th class="whiteSpace w-1">
                                    
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- <tr v-if="ajax_call_in_progress" class="text-center font-weight-bold">
                                <td colspan="4">
                                    <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center position-relative"/>
                                </td>
                            </tr>
                            <tr v-if="!ajax_call_in_progress && list_data.length == 0" class="text-center font-weight-bold">
                                <td colspan="4" class="text-center">No Data Found</td>
                            </tr> -->
                            <!-- <tr v-else v-for="(data, index) in list_data" :key="index+'list_data'"> -->
                            <tr>
                                <td class="whiteSpace w-1 text-capitalize">
                                    <span class="text-new-blue">
                                        Mathew C
                                    </span>
                                </td>
                                <td class="whiteSpace w-1 ">
                                    Maintenance
                                </td>
                                <td class="whiteSpace w-1">
                                    +91 7896541230
                                </td>
                                <td class="whiteSpace w-1">
                                    <!-- <span class="pointer whiteSpace buttons action-btns-show-hide">
                                        <button class="btn btn-icon actionicons update ml-3" style="height: 25px;padding: 5px !important;">
                                            <el-tooltip class="item" effect="dark" content="Delete" placement="top" style="bottom: 4.5px;">
                                                <i class="icon icon-trash deleteIcon"></i>
                                            </el-tooltip>
                                        </button>
                                    </span> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex align-items-center font-weight-bold mt-2 justify-content-end">
                    <button @click="firstPage()" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                        <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                            <i class="icon-chevron-double-left"></i>
                        </el-tooltip>    
                    </button>
                    <button @click="previousPage()" :disabled="skip == 0" class="pagination-list mt-1 ml-2 pointer">
                        <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                            <i class="icon icon-chevron-left"></i>
                        </el-tooltip>    
                    </button>
                    <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                    <button @click="nextPage()" :disabled="skip_temp >= total" class="pagination-list mt-1 mr-2 pointer">
                        <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                            <i class="icon icon-chevron-right"></i>
                        </el-tooltip>    
                    </button>
                    <button @click="lastPage()" class="mt-1 pointer pagination-list" :disabled ="temp_total == total">
                        <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                            <i class="icon-chevron-double-right"></i>
                        </el-tooltip>    
                    </button>
                </div>
            </div>
        </div>
        <add-emergency-contact v-if="create_modal" @hideModal="hideCreateModal" modal_name="Create-Modal" ></add-emergency-contact>
    </div>
</template>

<script>
import facility_mgmt from '../../mixins/facility_mgmt.js';
import { SweetModal } from 'sweet-modal-vue';
import { EventBus } from '../../eventBus/nav-bar-event.js';
import time_utils from '../../mixins/time_utils.js';
const AddEmergencyContact = () => import('./AddEmergencyContact.vue')
export default {
    mixins: [facility_mgmt, time_utils],
    components: {
        SweetModal,
        AddEmergencyContact
    },
    data() {
        return {
            success_msg: '',
            warning_msg: '',
            create_modal: false,
            list_data: [],
            ajax_call_in_progress: false,
            mode: 'create',
            workshift_id: '',
            skip:0,
            limit:10,
            total:0,
            temp_total:0,
            search_key:'',
            pageLimit: [],
            skip_temp: 0,
            count:0,
        }
    },
    methods: {
        hideCreateModal() {
            this.create_modal = false;
            setTimeout(() => {
                this.$modal.hide('Create-Modal');
            }, 500);
        },
        showCreateModal() {
            this.mode = 'create';
            this.create_modal = true;
            setTimeout(() => {
                this.$modal.show('Create-Modal');
            }, 500);
        },
        showEditModal(id) {
            this.mode = 'edit';
            this.create_modal = true;
            setTimeout(() => {
                this.$modal.show('Create-Modal');
            }, 500);
        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = 10
            this.list_data = []
            // this.getListData()
        },
        lastPage(){
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            // this.getListData();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            // this.getListData();
        },
        previousPage() {
            this.skip_temp = 0
            this.temp_total = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            // this.getListData();
        },
    },
    computed: {
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
    }
}
</script>
<style scoped>

</style>